import Container from "./Container";

export default function Footer() {
    return (
        <Container>
            <div className="body">
                <div>
                    <p className="copyright">Copyright © 2024, Max Goddard</p>
                    <p className="copyright">All rights reserved.</p>
                </div>
                <div>

                </div>
            </div>
        </Container>
    );
}